<script setup lang="ts">
import PlanCard from './PlanCard.vue';

const props = defineProps<{
    content: Record<string, string | null>;
}>();

const planKeys = ['plan_1', 'plan_2', 'plan_3', 'plan_4'] as const;

const plans = planKeys.map((slot) => ({
    slot,
    title: props.content[`plans.${slot}.title`] ?? '',
    price: props.content[`plans.${slot}.price`] ?? undefined,
    description: props.content[`plans.${slot}.description`] ?? '',
    learnMoreHref: props.content[`plans.${slot}.href`] ?? '#',
}));
</script>

<template>
    <section class="bg-white px-4 py-16 md:px-20 md:py-24">
        <div
            class="mx-auto flex max-w-[1330px] flex-col items-center gap-10 lg:flex-row lg:items-start md:gap-20"
        >
            <h3
                class="shrink-0 whitespace-pre-line text-center font-serif text-[35px] leading-[49px] text-primary md:leading-[43.2px]"
            >
                {{ content['plans.heading'] }}
            </h3>

            <div class="grid w-full grid-cols-1 gap-5 md:grid-cols-2">
                <PlanCard
                    v-for="plan in plans"
                    :key="plan.slot"
                    :title="plan.title"
                    :price="plan.price ?? undefined"
                    :description="plan.description"
                    :learn-more-href="plan.learnMoreHref"
                />
            </div>
        </div>
    </section>
</template>
